export const
	APP_DOMAIN 			= 'save.ltdhunt.com'

export const
	APP_BASE_URL 		= `https://${APP_DOMAIN}`,
	WORKERS_BASE_URL	= 'https://api.save.ltdhunt.com/v1',
	LEGACY_WORKERS_BASE_URL=`https://stella.raindrop.io`

export const
	RECAPTCHA_SITE_KEY = '6LfB38wUAAAAAMX3VuFcriTz-Tb-qw7MD966XNnk'

export const
	API_ENDPOINT_URL 	= `${process.env.NODE_ENV == 'production' || RAINDROP_ENVIRONMENT == 'react-native' ? 'https://api.save.ltdhunt.com' : 'http://localhost:8787' }/v1/`,
	API_RETRIES 		= 3,
	API_TIMEOUT 		= 30000,
	FAVICON_URL 		= `${WORKERS_BASE_URL}/favicon`,
	RENDER_URL 			= `${WORKERS_BASE_URL}/render`,
	PREVIEW_URL			= 'https://api.save.ltdhunt.com/v1/preview',
	BETA_AI_URL			= 'https://api.save.ltdhunt.com/v1/ai'